import React from 'react';
import { isNil } from 'ramda';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';

import AvatarWithBadge from 'sharedComponents/AvatarWithBadge';
import ChatUserPresenter from 'presenters/ChatUserPresenter';
import MessagePresenter from 'presenters/MessagePresenter';
import TextMessage from './components/TextMessage';
import VideoMessage from './components/VideoMessage';
import BidMessage from './components/BidMessage';

import useStyles from './useStyles';

const MESSAGE_TYPE_MAPPER = {
  text: TextMessage,
  video: VideoMessage,
  bid: BidMessage,
};

const Message = props => {
  const classes = useStyles();
  const { author, message, isCurrentUserMessage, chatUid, isFirstMessage } = props;
  const type = MessagePresenter.type(message);
  const MessageComponent = MESSAGE_TYPE_MAPPER[type];
  if (isNil(MessageComponent)) return null;

  return (
    <div className={clsx(classes.container)}>
      <div className={clsx(classes.messageContainer)}>
        <AvatarWithBadge
          isOnline={ChatUserPresenter.isOnline(author)}
          imageUrl={ChatUserPresenter.profileImageUrl(author)}
          label={ChatUserPresenter.initials(author)}
          size="m"
          className={classes.avatar}
        />
        <div className={classes.messageBox}>
          <Typography variant="subtitle1" color="secondary" className={clsx(classes.signature)}>
            <b>{ChatUserPresenter.fullName(author)}</b>&nbsp;&nbsp;{MessagePresenter.formatedSentTimeFromNow(message)}
          </Typography>
          <MessageComponent
            message={message}
            isCurrentUserMessage={isCurrentUserMessage}
            chatUid={chatUid}
            isFirstMessage={isFirstMessage}
          />
        </div>
      </div>
    </div>
  );
};

Message.propTypes = {
  author: ChatUserPresenter.shape().isRequired,
  chatUid: PropTypes.string.isRequired,
  message: MessagePresenter.shape().isRequired,
  isCurrentUserMessage: PropTypes.bool.isRequired,
};

export default Message;



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/Message.js